import { __rest, __assign } from 'tslib';
import React, { forwardRef, useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { useFocus } from '@alfalab/hooks';

var defaultColors = {"primary":"link__primary_zrjz1","secondary":"link__secondary_zrjz1","defaultView":"link__defaultView_zrjz1"};
require('./default.css')

var styles = {"component":"link__component_1ubue","text":"link__text_1ubue","withAddons":"link__withAddons_1ubue","focused":"link__focused_1ubue","pseudo":"link__pseudo_1ubue","withoutUnderline":"link__withoutUnderline_1ubue","addons":"link__addons_1ubue"};
require('./index.css')

var invertedColors = {"primary":"link__primary_1xq7c","secondary":"link__secondary_1xq7c","defaultView":"link__defaultView_1xq7c"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var Link = forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.view, view = _d === void 0 ? 'primary' : _d, _e = _a.pseudo, pseudo = _e === void 0 ? false : _e, _f = _a.underline, underline = _f === void 0 ? true : _f, leftAddons = _a.leftAddons, rightAddons = _a.rightAddons, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, _g = _a.colors, colors = _g === void 0 ? 'default' : _g, href = _a.href, _h = _a.Component, Component = _h === void 0 ? pseudo ? 'button' : 'a' : _h, restProps = __rest(_a, ["view", "pseudo", "underline", "leftAddons", "rightAddons", "className", "dataTestId", "children", "colors", "href", "Component"]);
    var linkRef = useRef(null);
    var focused = useFocus(linkRef, 'keyboard')[0];
    var viewClassName = view === 'default' ? 'defaultView' : view;
    var componentProps = __assign((_b = { className: cn(styles.component, colorStyles[colors][viewClassName], (_c = {},
                _c[styles.withoutUnderline] = !underline && !pseudo,
                _c[styles.pseudo] = pseudo,
                _c[styles.focused] = focused,
                _c[styles.withAddons] = leftAddons || rightAddons,
                _c), className), 'data-test-id': dataTestId, rel: restProps.target === '_blank' ? 'noreferrer noopener' : undefined }, _b[typeof Component === 'string' ? 'href' : 'to'] = href, _b), (pseudo && { type: 'button' }));
    return (React.createElement(Component, __assign({}, componentProps, restProps, { ref: mergeRefs([linkRef, ref]) }), leftAddons || rightAddons ? (React.createElement(React.Fragment, null,
        leftAddons && React.createElement("span", { className: styles.addons }, leftAddons),
        children && (React.createElement("span", null,
            React.createElement("span", { className: styles.text }, children))),
        rightAddons && React.createElement("span", { className: styles.addons }, rightAddons))) : (React.createElement("span", { className: styles.text }, children))));
});
/**
 * Для отображения в сторибуке
 */
Link.defaultProps = {
    view: 'primary',
    pseudo: false,
};
Link.displayName = 'Link';

export { Link };
